import { Injectable } from '@angular/core';
import { HttpHeaders, HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class BroadcastingsDaoService {

  private BASE_URL = environment.apiURL;
  private OPTIONS = {
    headers: new HttpHeaders({
      'Content-Type':  'application/json; charset=UTF-8'
    })
  };

  constructor( private http: HttpClient ) { }

  public getBroadcastings(context, lang, udid) {
    const options = {};
    Object.assign(options, this.OPTIONS);
    options['headers'] = options['headers'].append('context', context);
    options['headers'] = options['headers'].append('lang', lang);
    options['headers'] = options['headers'].append('udid', udid);
    const item = { };
    return this.http.post(this.BASE_URL + 'private/v2.0/broadcastingMaintenance/ws_listBroadcasting', item, options);
  }
  public getBroadcastingsCounts(context, lang, udid) {
    const options = {};
    Object.assign(options, this.OPTIONS);
    options['headers'] = options['headers'].append('context', context);
    options['headers'] = options['headers'].append('lang', lang);
    options['headers'] = options['headers'].append('udid', udid);
    return this.http.get(this.BASE_URL + 'private/v2.0/broadcastingMaintenance/count', options);
  }
  public getBroadcastingInfo(context, lang, udid, internalId) {
    const options = {};
    Object.assign(options, this.OPTIONS);
    options['headers'] = options['headers'].append('context', context);
    options['headers'] = options['headers'].append('lang', lang);
    options['headers'] = options['headers'].append('udid', udid);
    const item = { internalId };
    return this.http.post(this.BASE_URL + 'private/v2.0/broadcastingMaintenance/ws_getBroadcastingDetails', item, options);
  }
  public addNewBroadcasting(context, lang, udid, active, broadcastingName, centerBound, devicesBound) {
    const options = {};
    Object.assign(options, this.OPTIONS);
    options['headers'] = options['headers'].append('context', context);
    options['headers'] = options['headers'].append('lang', lang);
    options['headers'] = options['headers'].append('udid', udid);
    const item = { active, broadcastingName, centerBound, devicesBound };
    return this.http.post(this.BASE_URL + 'private/v2.0/broadcastingMaintenance/ws_saveBroadcasting', item, options);
  }
  public getBroadcastingScheduleInfo(context, lang, udid, internalId, relatedEntityInternalId) {
    const options = {};
    Object.assign(options, this.OPTIONS);
    options['headers'] = options['headers'].append('context', context);
    options['headers'] = options['headers'].append('lang', lang);
    options['headers'] = options['headers'].append('udid', udid);
    const item = { internalId, relatedEntityInternalId };
    return this.http.post(this.BASE_URL + 'private/v2.0/broadcastingMaintenance/ws_getBroadcastingCalendar', item, options);
  }
  public updateBroadcastingInfo(context, lang, udid, broadcastingInternalId, active, broadcastingName, showApp) {
    const options = {};
    Object.assign(options, this.OPTIONS);
    options['headers'] = options['headers'].append('context', context);
    options['headers'] = options['headers'].append('lang', lang);
    options['headers'] = options['headers'].append('udid', udid);
    const item = { broadcastingInternalId, active, broadcastingName, showApp };
    return this.http.post(this.BASE_URL + 'private/v2.0/broadcastingMaintenance/ws_saveBroadcasting', item, options);
  }
  public updateBroadcastingSchedules(context, lang, udid, broadcastingInternalId, active, showApp, broadcastingCalendars) {
    const options = {};
    Object.assign(options, this.OPTIONS);
    options['headers'] = options['headers'].append('context', context);
    options['headers'] = options['headers'].append('lang', lang);
    options['headers'] = options['headers'].append('udid', udid);
    const item = { broadcastingInternalId, active, broadcastingCalendars, showApp };
    return this.http.post(this.BASE_URL + 'private/v2.0/broadcastingMaintenance/ws_saveBroadcasting', item, options);
  }
  public updateBroadcastingCenters(context, lang, udid, broadcastingInternalId, active, showApp, centerBound) {
    const options = {};
    Object.assign(options, this.OPTIONS);
    options['headers'] = options['headers'].append('context', context);
    options['headers'] = options['headers'].append('lang', lang);
    options['headers'] = options['headers'].append('udid', udid);
    const item = { broadcastingInternalId, active, centerBound, showApp };
    return this.http.post(this.BASE_URL + 'private/v2.0/broadcastingMaintenance/ws_saveBroadcasting', item, options);
  }
  public updateBroadcastingDevices(context, lang, udid, broadcastingInternalId, active, showApp, devicesBound) {
    const options = {};
    Object.assign(options, this.OPTIONS);
    options['headers'] = options['headers'].append('context', context);
    options['headers'] = options['headers'].append('lang', lang);
    options['headers'] = options['headers'].append('udid', udid);
    const item = { broadcastingInternalId, active, devicesBound, showApp };
    return this.http.post(this.BASE_URL + 'private/v2.0/broadcastingMaintenance/ws_saveBroadcasting', item, options);
  }
  public updateBroadcastingGallery(context, lang, udid, broadcastingInternalId, active, showApp, broadcastingElements) {
    const options = {};
    Object.assign(options, this.OPTIONS);
    options['headers'] = options['headers'].append('context', context);
    options['headers'] = options['headers'].append('lang', lang);
    options['headers'] = options['headers'].append('udid', udid);
    const item = { broadcastingInternalId, active, broadcastingElements, showApp };
    return this.http.post(this.BASE_URL + 'private/v2.0/broadcastingMaintenance/ws_saveBroadcasting', item, options);
  }
  public deleteBroadcasting(context, lang, udid, internalId) {
    const options = {};
    Object.assign(options, this.OPTIONS);
    options['headers'] = options['headers'].append('context', context);
    options['headers'] = options['headers'].append('lang', lang);
    options['headers'] = options['headers'].append('udid', udid);
    const item = {internalId };
    return this.http.post(this.BASE_URL + 'private/v2.0/broadcastingMaintenance/ws_deleteBroadcasting', item, options);
  }
  public addNewBroadcastingSchedule(context, lang, udid, relatedEntityInternalId, mon, tue, wed, thu, fri, sat, sun, openTimeMorning, closeTimeMorning, openTimeAfternoon, closeTimeAfternoon, startDate, endDate, openService, commentNote, timeZone) {
    const options = {};
    Object.assign(options, this.OPTIONS);
    options['headers'] = options['headers'].append('context', context);
    options['headers'] = options['headers'].append('lang', lang);
    options['headers'] = options['headers'].append('udid', udid);
    const item = { relatedEntityInternalId, mon, tue, wed, thu, fri, sat, sun, openTimeMorning, closeTimeMorning, openTimeAfternoon, closeTimeAfternoon, startDate, endDate, openService, commentNote, timeZone };
    return this.http.post(this.BASE_URL + 'private/v2.0/broadcastingMaintenance/ws_saveBroadcastingCalendar', item, options);
  }
  public updateBroadcastingSchedule(context, lang, udid, internalId, relatedEntityInternalId, mon, tue, wed, thu, fri, sat, sun, openTimeMorning, closeTimeMorning, openTimeAfternoon, closeTimeAfternoon, startDate, endDate, openService, commentNote, timeZone) {
    const options = {};
    Object.assign(options, this.OPTIONS);
    options['headers'] = options['headers'].append('context', context);
    options['headers'] = options['headers'].append('lang', lang);
    options['headers'] = options['headers'].append('udid', udid);
    const item = { internalId, relatedEntityInternalId, mon, tue, wed, thu, fri, sat, sun, openTimeMorning, closeTimeMorning, openTimeAfternoon, closeTimeAfternoon, startDate, endDate, openService, commentNote, timeZone };
    return this.http.post(this.BASE_URL + 'private/v2.0/broadcastingMaintenance/ws_saveBroadcastingCalendar', item, options);
  }
  public deleteBroadcastingSchedule(context, lang, udid, internalId, relatedEntityInternalId) {
    const options = {};
    Object.assign(options, this.OPTIONS);
    options['headers'] = options['headers'].append('context', context);
    options['headers'] = options['headers'].append('lang', lang);
    options['headers'] = options['headers'].append('udid', udid);
    const item = { internalId, relatedEntityInternalId };
    return this.http.post(this.BASE_URL + 'private/v2.0/broadcastingMaintenance/ws_deleteBroadcastingCalendar', item, options);
  }
  public updateBroadcastingStatus(context, lang, udid, internalId) {
    const options = {};
    Object.assign(options, this.OPTIONS);
    options['headers'] = options['headers'].append('context', context);
    options['headers'] = options['headers'].append('lang', lang);
    options['headers'] = options['headers'].append('udid', udid);
    const item = { internalId };
    return this.http.post(this.BASE_URL + 'private/v2.0/broadcastingMaintenance/ws_changeStatusBroadcasting', item, options);
  }
  public getBroadcastingDevices(context, lang, udid, internalIdList) {
    const options = {};
    Object.assign(options, this.OPTIONS);
    options['headers'] = options['headers'].append('context', context);
    options['headers'] = options['headers'].append('lang', lang);
    options['headers'] = options['headers'].append('udid', udid);
    const item = { internalIdList };
    return this.http.post(this.BASE_URL + 'private/v2.0/broadcastingMaintenance/ws_listBroadcastingDevices', item, options);
  }
  public getTvFormatDevicesCounts(context, lang, udid) {
    const options = {};
    Object.assign(options, this.OPTIONS);
    options['headers'] = options['headers'].append('context', context);
    options['headers'] = options['headers'].append('lang', lang);
    options['headers'] = options['headers'].append('udid', udid);
    return this.http.get(this.BASE_URL + 'private/v2.0/tvConfigMaintenance/count', options);
  }
  public getTvFormatDevices(context, lang, udid) {
    const options = {};
    Object.assign(options, this.OPTIONS);
    options['headers'] = options['headers'].append('context', context);
    options['headers'] = options['headers'].append('lang', lang);
    options['headers'] = options['headers'].append('udid', udid);
    const item = { };
    return this.http.post(this.BASE_URL + 'private/v2.0/tvConfigMaintenance/ws_listDeviceTvConfig', item, options);
  }
  public getTvFormatDeviceInfo(context, lang, udid, internalId) {
    const options = {};
    Object.assign(options, this.OPTIONS);
    options['headers'] = options['headers'].append('context', context);
    options['headers'] = options['headers'].append('lang', lang);
    options['headers'] = options['headers'].append('udid', udid);
    const item = { internalId };
    return this.http.post(this.BASE_URL + 'private/v2.0/tvConfigMaintenance/ws_getDeviceTvConfigDetails', item, options);
  }
  public getTvFormatLayouts(context, lang, udid, internalId ) {
    const options = {};
    Object.assign(options, this.OPTIONS);
    options['headers'] = options['headers'].append('context', context);
    options['headers'] = options['headers'].append('lang', lang);
    options['headers'] = options['headers'].append('udid', udid);
    const item = { internalId };
    return this.http.post(this.BASE_URL + 'private/v2.0/tvConfigMaintenance/ws_listFormatsAndDesk', item, options);
  }
  public getBroadcastingLayouts(context, lang, udid) {
    const options = {};
    Object.assign(options, this.OPTIONS);
    options['headers'] = options['headers'].append('context', context);
    options['headers'] = options['headers'].append('lang', lang);
    options['headers'] = options['headers'].append('udid', udid);
    const item = { };
    options['params'] = item;
    return this.http.get(this.BASE_URL + 'private/v2.0/broadcasting/config/tvFormats', options);
  }
  public getBroadcastCenterConfig(context, lang, udid, centerInternalId) {
    const options = {};
    Object.assign(options, this.OPTIONS);
    options['headers'] = options['headers'].append('context', context);
    options['headers'] = options['headers'].append('lang', lang);
    options['headers'] = options['headers'].append('udid', udid);
    const item = { centerInternalId };
    options['params'] = item;
    return this.http.get(this.BASE_URL + 'private/v2.0/broadcasting/config/center', options);
  }
  public updateBroadcastCenterConfig(
    context, lang, udid, centerInternalId, layoutInternalId,
    backgroundColor, textPrimaryColor, textSecondaryColor,
    overrideDevicesValues, showOfflineChip
  ) {
    const options = {};
    Object.assign(options, this.OPTIONS);
    options['headers'] = options['headers'].append('context', context);
    options['headers'] = options['headers'].append('lang', lang);
    options['headers'] = options['headers'].append('udid', udid);
    const item = { centerInternalId, layoutInternalId, backgroundColor, textPrimaryColor, textSecondaryColor, overrideDevicesValues, showOfflineChip };
    return this.http.patch(this.BASE_URL + 'private/v2.0/broadcasting/config/center', item, options);
  }
  public getTvFormatDesks(context, lang, udid, internalId ) {
    const options = {};
    Object.assign(options, this.OPTIONS);
    options['headers'] = options['headers'].append('context', context);
    options['headers'] = options['headers'].append('lang', lang);
    options['headers'] = options['headers'].append('udid', udid);
    const item = { internalId };
    return this.http.post(this.BASE_URL + 'private/v2.0/tvConfigMaintenance/ws_listFormatsAndDesk', item, options);
  }
  public updateTvFormatLayout(context, lang, udid, internalId, tvLayoutInternalId, checkPrincipalDesk, principalDeskInternalId, backgroundColour, textPrimaryColour, textSecondaryColour) {
    const options = {};
    Object.assign(options, this.OPTIONS);
    options['headers'] = options['headers'].append('context', context);
    options['headers'] = options['headers'].append('lang', lang);
    options['headers'] = options['headers'].append('udid', udid);
    const item = { internalId, tvLayoutInternalId, checkPrincipalDesk, principalDeskInternalId, tvLayout: { backgroundColour, textPrimaryColour, textSecondaryColour } };
    return this.http.post(this.BASE_URL + 'private/v2.0/tvConfigMaintenance/ws_saveDeviceTvConfig', item, options);
  }
  public updateTvFormatWidget(context, lang, udid, internalId, socialNetworkList, checkPrincipalDesk, principalDeskInternalId) {
    const options = {};
    Object.assign(options, this.OPTIONS);
    options['headers'] = options['headers'].append('context', context);
    options['headers'] = options['headers'].append('lang', lang);
    options['headers'] = options['headers'].append('udid', udid);
    const item = { internalId, socialNetworkList, checkPrincipalDesk, principalDeskInternalId };
    return this.http.post(this.BASE_URL + 'private/v2.0/tvConfigMaintenance/ws_saveDeviceTvConfig', item, options);
  }

  public forceBroadcastingUpdate(context, lang, udid, internalId) {
    const options = {};
    Object.assign(options, this.OPTIONS);
    options['headers'] = options['headers'].append('context', context);
    options['headers'] = options['headers'].append('lang', lang);
    options['headers'] = options['headers'].append('udid', udid);
    const item = { internalId };
    return this.http.post(this.BASE_URL + 'private/v2.0/broadcastingMaintenance/ws_pushDeviceForUpdateBroadcasting', item, options);
  }

  public forceAllBroadcastingsUpdate(context, lang, udid) {
    const options = {};
    Object.assign(options, this.OPTIONS);
    options['headers'] = options['headers'].append('context', context);
    options['headers'] = options['headers'].append('lang', lang);
    options['headers'] = options['headers'].append('udid', udid);
    const item = {  };
    return this.http.post(this.BASE_URL + 'private/v2.0/broadcastingMaintenance/pushUpdateAllBroadcast', item, options);
  }

  public getBroadcastingExistingSchedules(context, lang, udid, internalIds) {
    const options = {};
    Object.assign(options, this.OPTIONS);
    options['headers'] = options['headers'].append('context', context);
    options['headers'] = options['headers'].append('lang', lang);
    options['headers'] = options['headers'].append('udid', udid);
    const item = { internalIds };
    return this.http.post(this.BASE_URL + 'private/v2.0/calendar/list/multiple', item, options);
  }

  public linkExistingBroadcastingSchedule(context, lang, udid, internalId, relatedEntityInternalId) {
    const options = {};
    Object.assign(options, this.OPTIONS);
    options['headers'] = options['headers'].append('context', context);
    options['headers'] = options['headers'].append('lang', lang);
    options['headers'] = options['headers'].append('udid', udid);
    const item = { internalId, relatedEntityInternalId };
    return this.http.post(this.BASE_URL + 'private/v2.0/broadcastingMaintenance/ws_linkBroadcastingCalendar', item, options);
  }

  public getBroadcastingGridDeviceView(context, lang, udid, dateType, centerInternalIds) {
    const options = {};
    Object.assign(options, this.OPTIONS);
    options['headers'] = options['headers'].append('context', context);
    options['headers'] = options['headers'].append('lang', lang);
    options['headers'] = options['headers'].append('udid', udid);
    const item = { dateType, centerInternalIds };
    options['params'] = item;
    return this.http.get(this.BASE_URL + 'private/v2.0/broadcastingMaintenance/grid/devices', options);
  }

  public getBroadcastingGridBroadcastingView(context, lang, udid, dateType, centerInternalIds) {
    const options = {};
    Object.assign(options, this.OPTIONS);
    options['headers'] = options['headers'].append('context', context);
    options['headers'] = options['headers'].append('lang', lang);
    options['headers'] = options['headers'].append('udid', udid);
    const item = { dateType, centerInternalIds };
    options['params'] = item;
    return this.http.get(this.BASE_URL + 'private/v2.0/broadcastingMaintenance/grid/broadcasting', options);
  }

  public getBroadcastingsConfig(context, lang, udid) {
    const options = {};
    Object.assign(options, this.OPTIONS);
    options['headers'] = options['headers'].append('context', context);
    options['headers'] = options['headers'].append('lang', lang);
    options['headers'] = options['headers'].append('udid', udid);
    const item = { };
    options['params'] = item;
    return this.http.get(this.BASE_URL + 'private/v2.0/broadcasting/config', options);
  }

  public updateBroadcastingsAssignmentModeConfig(context, lang, udid, assignmentMode) {
    const options = {};
    Object.assign(options, this.OPTIONS);
    options['headers'] = options['headers'].append('context', context);
    options['headers'] = options['headers'].append('lang', lang);
    options['headers'] = options['headers'].append('udid', udid);
    const item = { assignmentMode };
    return this.http.patch(this.BASE_URL + 'private/v2.0/broadcasting/config', item, options);
  }

  public updateBroadcastCenterConfigBackgroundImage(context, lang, udid, centerInternalId, backgroundImageUrl) {
    const options = {};
    Object.assign(options, this.OPTIONS);
    options['headers'] = options['headers'].append('context', context);
    options['headers'] = options['headers'].append('lang', lang);
    options['headers'] = options['headers'].append('udid', udid);
    const item = { centerInternalId, backgroundImageUrl };
    return this.http.patch(this.BASE_URL + 'private/v2.0/broadcasting/config/center', item, options);
  }

}
